<template>
  <div>
    <div class="inner">
      <p class="airport">{{item.airportName}}</p>
      <div class="info">
        <p class="name">{{item.Name}}</p>
        <p class="city colorGrey">{{`${item.City}, ${item.Country}`}}</p>
        <p class="long">{{distance(item.distanceKM)}}</p>
      </div>
    </div>
    <div class="btns">
      <!-- <router-link class="btn btnWhite"
        :to="{
        name: 'airportInfo',
        params: { lang: lang, airport: item.airportName }}">
        공항정보
      </router-link> -->
      <button class="btn btnWhite"
        :class="{btnLoading: loadinfInfo}"
        @click="onClickAirport">
        {{locale.airport_information}}
      </button>
      <router-link class="btn"
        :to="{
        name: 'flightSchedule',
        params: { lang: lang, airport: item.airportName }}">
        {{locale.flight_schedule}}
      </router-link>
    </div>
    <AirportDetail
      v-if="detail && info !== null"
      :locale="locale"
      :lang="lang"
      :info="info" />
  </div>
</template>

<script>
import AirportDetail from '@/components/FlightInfo/AirportDetail.vue'
export default {
  name: 'AirportItem',
  props: [
    'locale',
    'lang',
    'item'
  ],
  components: {
    AirportDetail
  },
  data () {
    return {
      detail: false,
      info: null,
      loadinfInfo: false
    }
  },
  methods: {
    distance (km) {
      return `${this.locale.localinfo_fromhotel} ${km.toFixed()}km`
    },
    onClickAirport () {
      const airport = this.item.airportName
      if (!this.detail) {
        this.loadinfInfo = true
        this.$store.dispatch('flightinfo/getAirportInfo', airport).then((res) => {
          if (res) {
            this.info = res
          } else {
            alert('공항정보를 불러오지 못했습니다.')
          }
          this.detail = true
          this.loadinfInfo = false
        })
      } else {
        this.detail = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.airport {
  text-align: center;
  font-size: 2em;
  font-weight: 700;
  border-bottom: 1px solid $color-lgrey2;
}
.info {
  padding: 15px;
}
.name {
  font-weight: 700;
}
.long {
  font-size: 0.85em;
  color: $color-lgrey;
}
.btns {
  display: flex;
  .btn {
    flex: 1;
    padding: 15px 0;
    text-align: center;
    &:first-child {
      border-color: transparent;
      border-top-color: $color-lgrey2;
    }
    &.btnLoading {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color-white, 0.5) url('~@/assets/img/loading.svg') 50% 50% / contain no-repeat;
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .airportItem .inner {
    display: flex;
    align-items: center;
  }
  .airport {
    width: 140px;
    padding: 30px 0;
    font-size: 2.4em;
    border-bottom: none;
    border-right: 1px solid $color-lgrey2;
  }
  .info {
    padding: 0 30px;
  }
}
</style>
